var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Teamwork"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3459_2605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3459_2605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "groups",
    d: "M3 61C2.15 61 1.4375 60.7125 0.8625 60.1375C0.2875 59.5625 0 58.85 0 58V56.275C0 54.075 1.1 52.3125 3.3 50.9875C5.5 49.6625 8.4 49 12 49C12.65 49 13.2625 49.025 13.8375 49.075C14.4125 49.125 14.975 49.2 15.525 49.3C14.825 50.3 14.3125 51.375 13.9875 52.525C13.6625 53.675 13.5 54.9 13.5 56.2V61H3ZM21 61C20.15 61 19.4375 60.7125 18.8625 60.1375C18.2875 59.5625 18 58.85 18 58V56.2C18 52.95 19.6625 50.3125 22.9875 48.2875C26.3125 46.2625 30.65 45.25 36 45.25C41.4 45.25 45.75 46.2625 49.05 48.2875C52.35 50.3125 54 52.95 54 56.2V58C54 58.85 53.7125 59.5625 53.1375 60.1375C52.5625 60.7125 51.85 61 51 61H21ZM58.5 61V56.2C58.5 54.9 58.325 53.675 57.975 52.525C57.625 51.375 57.125 50.3 56.475 49.3C57.025 49.2 57.5875 49.125 58.1625 49.075C58.7375 49.025 59.35 49 60 49C63.6 49 66.5 49.6625 68.7 50.9875C70.9 52.3125 72 54.075 72 56.275V58C72 58.85 71.7125 59.5625 71.1375 60.1375C70.5625 60.7125 69.85 61 69 61H58.5ZM12 46C10.35 46 8.9375 45.4125 7.7625 44.2375C6.5875 43.0625 6 41.65 6 40C6 38.35 6.5875 36.9375 7.7625 35.7625C8.9375 34.5875 10.35 34 12 34C13.65 34 15.0625 34.5875 16.2375 35.7625C17.4125 36.9375 18 38.35 18 40C18 41.65 17.4125 43.0625 16.2375 44.2375C15.0625 45.4125 13.65 46 12 46ZM60 46C58.35 46 56.9375 45.4125 55.7625 44.2375C54.5875 43.0625 54 41.65 54 40C54 38.35 54.5875 36.9375 55.7625 35.7625C56.9375 34.5875 58.35 34 60 34C61.65 34 63.0625 34.5875 64.2375 35.7625C65.4125 36.9375 66 38.35 66 40C66 41.65 65.4125 43.0625 64.2375 44.2375C63.0625 45.4125 61.65 46 60 46ZM36 43C33.5 43 31.375 42.125 29.625 40.375C27.875 38.625 27 36.5 27 34C27 31.5 27.875 29.375 29.625 27.625C31.375 25.875 33.5 25 36 25C38.5 25 40.625 25.875 42.375 27.625C44.125 29.375 45 31.5 45 34C45 36.5 44.125 38.625 42.375 40.375C40.625 42.125 38.5 43 36 43Z",
    fill: "url(#paint0_linear_3459_2605)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3459_2605",
    x1: 19.062,
    y1: 25,
    x2: 23.7868,
    y2: 63.8196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEDDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1AEFE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/Teamwork.1734707a18dd870862b0e5bb1143df7f.svg";
export { ForwardRef as ReactComponent };